import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import Spinner from '../../util/spinner-shim'
import Modal from 'react-modal'
import { injectIntl } from 'react-intl'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import ModalPinCode from '../partials/SettingPageComponents/ModalPinCode'
import GridList from '../partials/GridList'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import TempSet from '../partials/SettingPageComponents/TempSet'
import Calibrate from '../partials/SettingPageComponents/Calibrate'
import Autostart from '../partials/SettingPageComponents/Autostart'
import TimeSet from '../partials/SettingPageComponents/TimeSet'
import Timeblocks from '../partials/SettingPageComponents/Timeblocks'
import Pump2Flow from '../partials/SettingPageComponents/Pump2Flow'
import FlowSettings from '../partials/SettingPageComponents/FlowSettings'
import Pump2Logic from '../partials/SettingPageComponents/Pump2Logic'
import Pump2Application from '../partials/SettingPageComponents/Pump2Application'
import Pump2Inputs from '../partials/SettingPageComponents/Pump2Inputs'
import Pump2Communications from '../partials/SettingPageComponents/Pump2Communications'
import SettlingTime from '../partials/SettingPageComponents/SettlingTime'
import FuelSensorControl from '../partials/SettingPageComponents/FuelSensorControl'
import RpmTarget from '../partials/SettingPageComponents/RpmTarget'
import WindMachine from '../partials/SettingPageComponents/WindMachine'
import FeedbackThreshold from '../partials/SettingPageComponents/FeedbackThreshold'
import SleepInterval from '../partials/SettingPageComponents/SleepInterval'
import Run from '../partials/SettingPageComponents/Run'
import Application from '../partials/SettingPageComponents/Application'
import RpmMultiplier from '../partials/SettingPageComponents/RpmMultiplier'
import DeviceNumber from '../partials/SettingPageComponents/DeviceNumber'
import DeviceGroup from '../partials/SettingPageComponents/DeviceGroup'
import IsActive from '../partials/SettingPageComponents/IsActive'
import DeviceType from '../partials/SettingPageComponents/DeviceType'
import Fuel from '../partials/SettingPageComponents/Fuel'
import Debounce from '../partials/SettingPageComponents/Debounce'
import Powered from '../partials/SettingPageComponents/Powered'
import PowerPort from '../partials/SettingPageComponents/PowerPort'
import RpmState from '../partials/SettingPageComponents/RpmState'
import VoltageScale from '../partials/SettingPageComponents/VoltageScale'
import FourToTwentyScale from '../partials/SettingPageComponents/FourToTwentyScale'
import { CapitalButton } from '../partials/Navigation/Buttons'

import AppDispatcher from '../../dispatchers/AppDispatcher'

// Import the HOC
import withAppStore from '../../util/withAppStore'

import HandCrushedDefault from '../partials/Graphics/HandCrushed'
import ValveInputs from '../partials/SettingPageComponents/ValveInputs'

import styles from '../../../css/devicePage.module.css'
import notificationStyles from '../../../css/notifications.module.css'

Modal.setAppElement('#app')

const warningModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '80%',
    width: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    border: 'none',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#d00000',
    color: '#fff',
  },
}

const changedModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '80%',
    width: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    border: 'none',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    color: '#284047',
  },
}

const SettingName = (setting) => {
  switch (setting) {
    case 'tempSet': {
      return 'Temperature'
    }
    case 'autostart': {
      return 'Auto Mode'
    }
    case 'timeSet': {
      return 'Schedule'
    }
    case 'timeblocks': {
      return 'Schedule'
    }
    case 'sleepInterval': {
      return 'Sleep Time'
    }
    case 'settlingTime': {
      return 'Settling Time'
    }
    case 'update': {
      return 'Update'
    }
    case 'calibrate': {
      return 'Calibrate'
    }
    case 'run': {
      return 'Run'
    }
    case 'application':
    case 'application1':
    case 'application2': {
      return 'Application'
    }
    case 'deviceNumber': {
      return 'Name'
    }
    case 'deviceGroup': {
      return 'Group'
    }
    case 'isActive': {
      return 'Active'
    }
    case 'deviceType': {
      return 'Type'
    }
    case 'rpmMultiplier': {
      return 'RPM Multiplier'
    }
    case 'fuelTankSize': {
      return 'Fuel Tank Size'
    }
    case 'fuelSensorRange': {
      return 'Fuel Sensor Range'
    }
    case 'pump2Inputs': {
      return 'Inputs'
    }
    case 'valveInputs': {
      return 'Valve Inputs'
    }
    case 'pump2Application': {
      return 'Application'
    }
    case 'pump2Flow': {
      return 'Flow'
    }
    case 'pump2Logic1': {
      return 'Logic Relay 1'
    }
    case 'pump2Logic2': {
      return 'Logic Relay 2'
    }
    case 'pump2Communications': {
      return 'Communication'
    }
    case 'fuelSensorControl': {
      return 'Fuel Sensor'
    }
    case 'rpmTarget': {
      return 'RPM Target'
    }
    case 'windMachine': {
      return 'Wind Machine'
    }
    case 'feedbackThreshold': {
      return 'Feedback Threshold'
    }
    case 'debounce': {
      return 'Debounce'
    }
    case 'powered': {
      return 'Powered'
    }
    case 'powerPort': {
      return 'Power Port'
    }
    case 'highRpm':
    case 'offRpm':
    case 'rpmState': {
      return 'RPM Calibration'
    }
    default:
      return ''
  }
}

function SettingPage (props) {
  const navigate = useNavigate()
  const params = useParams()
  const location = useLocation()

  const {
    data: {
      deviceSettings: {
        devices: devicesList = [],
        invalid = false,
        newSettings = [],
        saved,
      } = {},
      lookup = {},
      lookupReady = false,
      customer: {
        data: customerData = {},
        data: {
          security = {},
        } = {},
      } = {},
      pinCode: { status } = {},
      deviceReading = [],
      deviceReadingReady = false,
    } = {},
    auth: { logout: logoutFn } = {},
    intl: { formatMessage } = {},
    route: { path: page } = {},
    name: nameProp,
    location: {
      query: queryValue = {},
    } = {},
  } = props

  const { pin: pinRequired = false } = security || {}

  // State management
  const [device, setDevice] = useState(null)
  const [devices, setDevices] = useState([])
  const [isValid, setIsValid] = useState(true)
  const [isChanged, setIsChanged] = useState(false)
  const [warningModalIsOpen, setWarningModalIsOpen] = useState(false)
  const [changedModalIsOpen, setChangedModalIsOpen] = useState(false)
  const [showDevices, setShowDevices] = useState(false)
  const [isSelect, setIsSelect] = useState(false)
  const [goBackOnce, setGoBackOnce] = useState(false)

  const getNewData = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'get-device',
      deviceID: params.deviceID,
    })
  }, [params.deviceID])

  // Initialize data if needed
  useEffect(() => {
    if (params.deviceID) {
      getNewData()
    }
  }, [getNewData])

  // Initialize settings when device changes
  useEffect(() => {
    if (device) {
      AppDispatcher.dispatch({
        action: 'initialize-new-settings',
        device,
      })
    }
  }, [device])

  // Set up polling for device data updates
  useEffect(() => {
    if (params.deviceID) {
      const interval = setInterval(() => {
        // console.log('Polling for device updates:', params.deviceID)
        getNewData()
      }, props.data?.pollInterval || 5000)

      return () => clearInterval(interval)
    }
  }, [getNewData, params.deviceID, props.data?.pollInterval])

  // Handle device data updates
  useEffect(() => {
    const devices = []
    let currentDevice

    if (devicesList && devicesList.length > 0) {
      for (let i = 0; i < devicesList.length; i += 1) {
        devices.push(lookup[devicesList[i]])
      }
      currentDevice = devices[0]
    } else if (params.deviceID && lookup) {
      currentDevice = lookup[params.deviceID]
      // If not found by deviceID, try to find by any key that matches
      if (!currentDevice) {
        const lookupKeys = Object.keys(lookup)
        // Try to find device by matching any key that might be the device ID
        for (const key of lookupKeys) {
          const device = lookup[key]
          if (device && (device.id === params.deviceID || device.address === params.deviceID)) {
            currentDevice = device
            break
          }
        }
      }
      devices.push(currentDevice)
    } else if (params.customerID && params.deviceType) {
      navigate(`/${params.customerID}/${params.deviceType}`)
      return
    } else {
      navigate('/home')
      return
    }

    setDevice(currentDevice)
    setDevices(devices)
  }, [devicesList, lookup, lookupReady, params.deviceID, params.customerID, params.deviceType, navigate])

  const closeChangedModal = useCallback(() => {
    setChangedModalIsOpen(false)
  }, [])

  const backToDevice = useCallback(() => {
    const {
      data: { history: { list, past } } = {},
    } = props || {}
    const [, , , , page = '', setting] = (past && past.length > 1) ? past[0].split('/') : []

    let backPath = `/${params.customerID}/devices/${params.deviceID}`

    if (setting === 'tempSet' || setting === 'timeblocks' || setting === 'timeSet') {
      // done
    } else if (setting === 'application' || setting === 'sleepInterval') {
      backPath += '/admin'
    } else if (page === 'settings' || (page === '' && params.deviceID)) {
      // this is for the case that we came from an individual device setting page
      backPath += '/settings'
    } else if (page === 'admin') {
      // this is for the case that we came from an individual device admin page
      backPath += '/admin'
    } else if (params.customerID && params.deviceID) {
      // this is for the case we came from a individual device page
      // default - already set
    } else if (params.customerID && list.length > 0) {
      backPath = list
    } else if (page === '/settings/feedbackThreshold') {
      backPath += '/settings/pump2Inputs'
    } else {
      backPath = '/home'
    }

    closeChangedModal()
    return navigate(backPath)
  }, [params.customerID, params.deviceID, props.data.history, navigate, closeChangedModal])

  // Handle saved state
  useEffect(() => {
    if (saved === true && !goBackOnce) {
      setGoBackOnce(true)
      setTimeout(() => {
        backToDevice()
      }, 200)
    }
  }, [saved, goBackOnce, backToDevice])

  // Handle pin code cancellation
  useEffect(() => {
    const { pinCode: { cancelled } = {} } = props.data || {}
    if (cancelled === true && !goBackOnce) {
      setGoBackOnce(true)
      backToDevice()
    }
  }, [props.data?.pinCode?.cancelled, goBackOnce])

  // Cleanup on unmount
  useEffect(() => () => {
    AppDispatcher.dispatch({
      action: 'reset-new-settings',
    })
    AppDispatcher.dispatch({
      action: 'pin-code-unload',
    })
  }, [])

  const setValidity = useCallback((validity) => {
    setIsValid(!!validity)
  }, [])

  const setChanged = useCallback((changed) => {
    setIsChanged(!!changed)
  }, [])

  const toggleDevices = useCallback(() => {
    setShowDevices((prev) => !prev)
  }, [])

  const checkChanged = useCallback(() => {
    if (isChanged) {
      return openChangedModal()
    }
    return backToDevice()
  }, [isChanged])

  const backToInputs = useCallback(() => {
    const {
      data: { lookup, lookupReady } = {},
    } = props || {}

    let currentDevice = null
    if (lookupReady && lookup) {
      currentDevice = lookup[params.deviceID]
    }
    const { physical } = currentDevice || {}

    let backPath = `/${params.customerID}/devices/${params.deviceID}/settings`

    if (physical?.deviceType === 'pump') {
      backPath += '/pump2Inputs'
    } else if (physical?.deviceType === 'valve') {
      backPath += '/valveInputs'
    }

    return navigate(backPath)
  }, [params.customerID, params.deviceID, props.data.lookup, props.data.lookupReady, navigate])

  const saveToServer = useCallback(() => {
    const {
      data: { deviceSettings: { invalid: invalidSettings = false, newSettings: newSettingsData, newDeviceInfo } = {} } = {},
    } = props || {}

    if (invalidSettings) {
      closeWarningModal()
      return
    }

    if (params.deviceID && newDeviceInfo && Object.entries(newDeviceInfo).length > 0) {
      AppDispatcher.dispatch({
        action: 'set-device',
        deviceID: params.deviceID,
        data: newDeviceInfo,
      })
    }

    if (
      newSettingsData &&
      (typeof newSettingsData.settings === 'object' || (Array.isArray(newSettingsData) && newSettingsData.length > 0))
    ) {
      AppDispatcher.dispatch({
        action: 'set-settings',
        settings: newSettingsData,
      })
    }

    closeWarningModal()
    closeChangedModal()
  }, [params.deviceID, props.data.deviceSettings])

  const deleteItemValve = useCallback(() => {
    const { setting, settingNo } = params
    const { address } = device || {}
    const {
      application_settings: {
        settings: {
          valveTime: pastValveTime,
        } = {},
      } = {},
      application_settings_new: {
        settings: {
          valveTime: currentValveTime,
        } = {},
      } = {},
    } = devices[0] || {}
    const deleteNumber = Number.parseInt(settingNo, 10)
    const isSet = (object) => Object.prototype.toString.call(object) === '[object Array]'

    if (setting === 'timeSet' && deleteNumber) {
      let valveTime = [0, 0]

      if (isSet(currentValveTime)) {
        valveTime = currentValveTime
      } else if (isSet(pastValveTime)) {
        valveTime = pastValveTime
      }

      valveTime.splice((deleteNumber - 1) * 2, 2)

      AppDispatcher.dispatch({
        action: 'change-setting',
        setting: {
          address,
          status: 'new',
          settings: {
            valveTime,
          },
        },
      })
      saveToServer()
    }
  }, [params.setting, params.settingNo, device, devices, saveToServer])

  const toggleSelect = useCallback(() => {
    setIsSelect((prev) => !prev)
  }, [])

  const stopSelect = useCallback(() => {
    setIsSelect(false)
  }, [])

  const openWarningModal = useCallback(() => {
    setWarningModalIsOpen(true)
  }, [])

  const closeWarningModal = useCallback(() => {
    setWarningModalIsOpen(false)
  }, [])

  const openChangedModal = useCallback(() => {
    setChangedModalIsOpen(true)
  }, [])

  const logout = useCallback(() => {
    logoutFn(navigate)
  }, [logoutFn, navigate])

  let name = SettingName(params.setting)
  if (nameProp && typeof nameProp === 'string') name = nameProp

  let navBar = (
    <NavigationBar
      page={page}
      backFunc={checkChanged}
      name={name}
      logOut={logout}
    />
  )

  if (params.setting === 'timeSet' && Number.parseInt(params.settingNo, 10)) {
    navBar = (
      <NavigationBar
        page={page}
        backFunc={checkChanged}
        name={name}
        logOut={logout}
        rightControl={{
          icon: 'fa-trash-o',
          func: deleteItemValve,
        }}
      />
    )
  } else if (params.setting === 'timeblocks') {
    navBar = (
      <NavigationBar
        page={page}
        backFunc={checkChanged}
        name={name}
        logOut={logout}
        rightControl={{
          icon: isSelect ? 'fa-check-square-o' : 'fa-square-o',
          func: toggleSelect,
        }}
      />
    )
  } else if (params.setting === 'feedbackThreshold') {
    navBar = (
      <NavigationBar
        page={page}
        backFunc={backToInputs}
        name={name}
        logOut={logout}
        rightControl={{
          icon: isSelect ? 'fa-check-square-o' : 'fa-square-o',
          func: toggleSelect,
        }}
      />
    )
  }

  let warningModalText = ''
  let saveButtonFunction = saveToServer

  const { saveButton, saveButtonHidden, saveButtonSuccess, saveButtonError } = styles

  let saveButtonStyle = `${saveButton} saveButton`

  if (invalid || (pinRequired && status !== 'authenticated')) {
    saveButtonStyle += ` ${saveButtonHidden}`
  } else if (saved === true) {
    saveButtonStyle += ` ${saveButtonSuccess}`
  } else if (saved === 'error') {
    saveButtonStyle += ` ${saveButtonError}`
  }

  const { settings: { auto = -1, run = -1 } = {} } = (newSettings[0]) || {}

  if (auto === 1 || run === 1) {
    saveButtonFunction = openWarningModal
    warningModalText = formatMessage({
      id: 'settings.warnings.autostart',
      defaultMessage: `
        Auto and/or Start enables the wind machine to start automatically
        and without warning. Click OK if the machine is in operating
        condition and all personnel are clear of the machine.
        `,
      description: 'Warning: Auto and/or Start may cause machine to start without warning.',
    })
  }

  let settingDisplay
  if (!lookupReady || !device) {
    settingDisplay = (
      <div className='loading'>
        <Spinner name='double-bounce' />
      </div>
    )
  } else {
    const {
      modalHead,
      modalHeadNoMargin,
      modalHeadWarning,
      modalSave,
      modalSaveButton,
      modalSaveButtonWarning,
    } = notificationStyles

    let tileInfo = 'default'
    if (params.setting === 'rpmTarget') {
      tileInfo = 'rpm'
    }

    settingDisplay = (
      <div>
        <ModalPinCode required={pinRequired} status={status} pageChange />
        {devices && devices.length > 1
          ? (
            <div style={{ marginBottom: '20px' }}>
              <div className={styles.dropdown}>
                <span>
                  Target Device(s)
                </span>
                <button
                  className={styles.dropdown_plus}
                  onClick={toggleDevices}
                  type='button'
                >
                  {showDevices ? 'HIDE' : 'SHOW'}
                </button>
              </div>
              <div style={{ display: showDevices ? 'inherit' : 'none' }}>
                <GridList devices={devices} selectMode={false} tileInfo={tileInfo} />
              </div>
            </div>
            )
          : ''}
        <div
          style={{
            marginTop: device && devices.length < 2 ? '0px' : 0,
          }}
        >
          <Setting
            devices={devices}
            customer={customerData}
            params={params}
            setValidity={setValidity}
            setChanged={setChanged}
            deviceReading={deviceReading}
            deviceReadingReady={deviceReadingReady}
            isSelect={isSelect}
            stopSelect={stopSelect}
            router={{ push: navigate }}
            query={queryValue}
          />
        </div>
        <section>
          {!isSelect && (
            <CapitalButton
              text={formatMessage({
                id: 'setting.save',
                defaultMessage: 'SAVE',
                description: 'SAVE button',
              })}
              buttonFunction={saveButtonFunction}
              disabled={!isValid}
              hSize='h2'
              style={saveButtonStyle}
            />
          )}
          <br />
          <Modal
            isOpen={warningModalIsOpen}
            onRequestClose={closeWarningModal}
            style={warningModalStyles}
            contentLabel='warningModal'
          >
            <h3 className={`${modalHead} ${modalHeadNoMargin}`} style={{ textTransform: 'uppercase' }}>
              {formatMessage({
                id: 'general.warning',
                defaultMessage: 'WARNING',
              })}
              !
            </h3>
            <div className={styles.warningGraphic}>
              <HandCrushedDefault />
            </div>
            <h5 className={modalHeadWarning}>{warningModalText}</h5>
            <h3 className={modalSave}>
              <button className={modalSaveButtonWarning} style={{ textTransform: 'uppercase' }} onClick={saveToServer}>
                {formatMessage({
                  id: 'general.ok',
                  defaultMessage: 'OK',
                })}
              </button>
              <button
                className={modalSaveButton}
                style={{ textTransform: 'uppercase' }}
                onClick={closeWarningModal}
              >
                {formatMessage({
                  id: 'general.no',
                  defaultMessage: 'NO',
                })}
              </button>
            </h3>
          </Modal>
          <Modal
            isOpen={changedModalIsOpen}
            onRequestClose={closeChangedModal}
            style={changedModalStyles}
            contentLabel='changedModal'
          >
            <h3 className={`${modalHead} ${modalHeadNoMargin}`} style={{ textTransform: 'uppercase' }}>
              {formatMessage({
                id: 'general.warning',
                defaultMessage: 'WARNING',
              })}
              !
            </h3>
            <h5 className={modalHeadWarning}>Settings have changed without save.</h5>
            <h3 className={modalSave}>
              <button style={{ textTransform: 'uppercase' }} onClick={saveToServer}>
                {formatMessage({
                  id: 'general.save',
                  defaultMessage: 'SAVE',
                })}
              </button>
              <button
                style={{ textTransform: 'uppercase' }}
                onClick={backToDevice}
              >
                {formatMessage({
                  id: 'general.exit',
                  defaultMessage: 'EXIT',
                })}
              </button>
            </h3>
          </Modal>
        </section>
      </div>
    )
  }

  return (
    <div>
      <Helmet><title>{props.pages?.SettingPage || 'Settings'}</title></Helmet>
      {navBar}
      <div className={styles.pageWidth}>
        {settingDisplay}
        <div className={styles.endSpace} />
      </div>
      <Footer />
    </div>
  )
}

SettingPage.propTypes = {
  params: PropTypes.object,
  data: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
  auth: PropTypes.object,
  intl: PropTypes.object,
  name: PropTypes.string,
  location: PropTypes.object,
}

export default withAppStore(injectIntl(SettingPage))

const Setting = function Setting ({
  devices,
  customer,
  params,
  query,
  deviceReading,
  deviceReadingReady,
  setValidity,
  setChanged,
  isSelect,
  stopSelect,
}) {
  let settingReturn
  const [device] = devices

  switch (params.setting) {
    case 'tempSet': {
      settingReturn = <TempSet devices={devices} setValidity={setValidity} />
      break
    }
    case 'autostart': {
      settingReturn = <Autostart devices={devices} />
      break
    }
    case 'timeSet': {
      settingReturn = <TimeSet devices={devices} params={params} />
      break
    }
    case 'timeblocks': {
      settingReturn = (
        <Timeblocks
          devices={devices}
          params={params}
          setValidity={setValidity}
          setChanged={setChanged}
          isSelect={isSelect}
          stopSelect={stopSelect}
          limit={50}
        />
      )
      break
    }
    case 'sleepInterval': {
      settingReturn = <SleepInterval device={device} />
      break
    }
    case 'settlingTime': {
      settingReturn = <SettlingTime device={device} />
      break
    }
    case 'update': {
      // this was replaced with a combined tile for sleepInterval and update
      break
    }
    case 'calibrate': {
      settingReturn = <Calibrate devices={devices} />
      break
    }
    case 'run': {
      settingReturn = <Run device={device} />
      break
    }
    case 'application':
    case 'application1':
    case 'application2': {
      settingReturn = <Application device={device} setting={params.setting} />
      break
    }
    case 'deviceNumber': {
      settingReturn = <DeviceNumber device={device} />
      break
    }
    case 'deviceGroup': {
      settingReturn = <DeviceGroup device={device} customer={customer} />
      break
    }
    case 'isActive': {
      settingReturn = <IsActive device={device} customer={customer} />
      break
    }
    case 'deviceType': {
      settingReturn = <DeviceType device={device} />
      break
    }
    case 'rpmMultiplier': {
      settingReturn = <RpmMultiplier device={device} />
      break
    }
    case 'fuelTankSize': {
      settingReturn = <Fuel device={device} />
      break
    }
    case 'fuelSensorRange': {
      settingReturn = <Fuel device={device} />
      break
    }
    case 'pump2Inputs': {
      settingReturn = <Pump2Inputs device={device} setValidity={setValidity} />
      break
    }
    case 'valveInputs': {
      settingReturn = <ValveInputs device={device} setValidity={setValidity} targetDevice='SD' />
      break
    }
    case 'pump2Application': {
      settingReturn = <Pump2Application device={device} setValidity={setValidity} />
      break
    }
    case 'pump2Flow': {
      settingReturn = <Pump2Flow device={device} setValidity={setValidity} />
      break
    }
    case 'flowSettings': {
      settingReturn = <FlowSettings device={device} setValidity={setValidity} />
      break
    }
    case 'pump2Logic1': {
      settingReturn = <Pump2Logic device={device} setValidity={setValidity} actuator={1} />
      break
    }
    case 'pump2Logic2': {
      settingReturn = <Pump2Logic device={device} setValidity={setValidity} actuator={2} />
      break
    }
    case 'pump2Communications': {
      settingReturn = <Pump2Communications device={device} setValidity={setValidity} />
      break
    }
    case 'fuelSensorControl': {
      settingReturn = <FuelSensorControl device={device} setValidity={setValidity} />
      break
    }
    case 'rpmTarget': {
      settingReturn = <RpmTarget devices={devices} setValidity={setValidity} />
      break
    }
    case 'windMachine': {
      settingReturn = <WindMachine device={device} deviceReading={deviceReading} deviceReadingReady={deviceReadingReady} setValidity={setValidity} />
      break
    }
    case 'feedbackThreshold': {
      settingReturn = <FeedbackThreshold device={device} query={query} deviceReading={deviceReading} deviceReadingReady={deviceReadingReady} setValidity={setValidity} />
      break
    }
    case 'debounce': {
      settingReturn = <Debounce device={device} />
      break
    }
    case 'voltageScale': {
      settingReturn = <VoltageScale device={device} setValidity={setValidity} />
      break
    }
    case 'fourToTwentySD1': {
      settingReturn = <FourToTwentyScale device={device} setValidity={setValidity} targetDevice='SD' targetNumber={1} />
      break
    }
    case 'fourToTwentySD2': {
      settingReturn = <FourToTwentyScale device={device} setValidity={setValidity} targetDevice='SD' targetNumber={2} />
      break
    }
    case 'powered': {
      settingReturn = <Powered device={device} />
      break
    }
    case 'powerPort': {
      settingReturn = <PowerPort device={device} />
      break
    }
    case 'highRpm':
    case 'offRpm':
    case 'rpmState': {
      settingReturn = <RpmState device={device} />
      break
    }
    default:
      break
  }

  return (
    <div>
      <div>{settingReturn}</div>
    </div>
  )
}

Setting.propTypes = {
  devices: PropTypes.array,
  params: PropTypes.object,
}
